import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { styled } from 'styled-components';
import { EmojiGroupList } from './components/EmojiGroupList';
import { EmojiIconList } from './components/EmojiIconList';
import { EmojiSelection } from './components/EmojiSelection';
import { EmojiPickerProvider } from './context/EmojiPickerContext';
export const EmojiPicker = ({ doNotDisplay = [], emojiSelectionLabel = 'Pick your emoji above', maxVersion = '', onEmojiPick, }) => (_jsx(EmojiPickerProvider, { doNotDisplay: doNotDisplay, emojiSelectionLabel: emojiSelectionLabel, maxVersion: maxVersion, onEmojiPick: onEmojiPick, children: _jsxs(Wrapper, { children: [_jsx(EmojiGroupList, {}), _jsx(EmojiIconList, {}), _jsx(EmojiSelection, {})] }) }));
const Wrapper = styled(Box).attrs(() => ({
    bg: 'white',
    flexDirection: 'column',
    width: 320,
})) `
  border-radius: 2px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.2);
`;
//# sourceMappingURL=EmojiPicker.js.map